export const ReportAttendanceText = {
  titleText: 'Absensi',
  buttonExportText: 'Export',
  searchPlaceholder: 'Cari...',
  searchHostPlaceholder: 'Cari...',
  monthYearPickerPlaceholder: 'Pilih Bulan',
  datePlaceholder: 'Pilih Tanggal',
  brandPlaceholder: 'Pilih Brand',
};
